import { render } from "./page_builder.html?vue&type=template&id=33adf488&scoped=true&external"
import script from "./page_builder.js?vue&type=script&lang=js&external"
export * from "./page_builder.js?vue&type=script&lang=js&external"

import "./PageBuilder.vue?vue&type=style&index=0&id=33adf488&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33adf488"]])

export default __exports__